import { Component, OnInit, ViewChild, Input, AfterViewInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { EpButtonType, IEpButtonModel, EpButtonStyle } from '@epicor/kinetic';
import { FormBuilder, Validators, FormGroup } from '@angular/forms';
import { BistrackConfig, ObjectListType, CustomEvents, QuantityType } from 'ep-bt-controls';
import { EpEventService } from '@epicor/kinetic';
import { EpbtFaCompetitorService } from '../../services/epbt-fa-competitor.service';
import { EpbtFaProductService } from '../../services/epbt-fa-product.service';
import { CompetitorPriceLine } from '../../models/competitor-price-line.model';
import { Location } from '@angular/common';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'epbt-fa-competitor-pricing-line-negotiation',
  templateUrl: './epbt-fa-competitor-pricing-line-negotiation.component.html',
  styleUrls: ['./epbt-fa-competitor-pricing-line-negotiation.component.scss']
})
export class EpbtFaCompetitorPricingLineNegotiationComponent implements OnInit, AfterViewInit {

  EpButtonType = EpButtonType;
  EpButtonStyle = EpButtonStyle;

  competitorNegotiationForm: FormGroup;

  submitted = false;
  addCompetitorNegotiatin: any;
  priceId: number;
  selectedPrice: any;
  selectedPriceId: number;
  selectedProduct: any;
  finalCompetitorObj: any;
  updateFinalCompetitorObj: any;
  isPriceWarning = false;

  // selectedProductItem: any;

  productId: number;

  constructor(
    private route: Router,
    private location: Location,
    private fb: FormBuilder,
    private productService: EpbtFaProductService,
    private config: BistrackConfig,
    public epEvent: EpEventService,
    public epbtFaCompetitorService: EpbtFaCompetitorService
  ) { }

  buttonModel: IEpButtonModel = {
    type: EpButtonType.Submit
  };

  ngOnInit() {
    this.productId = this.productService.selectedProductItem.productId;
    this.loadCompetitorForm();
  }

  ngAfterViewInit() {
    this.patchValues();
    // if (this.epbtFaCompetitorService.selectedProductsForBinding.length > 0 && this.epbtFaCompetitorService.isNegotiationEdit) {
    //   let lineItem = this.epbtFaCompetitorService.selectedProductsForBinding.find(item => item.product.productId == this.productId);
    //   if (lineItem) {
    //     this.competitorNegotiationForm.patchValue({
    //       price: lineItem.price,
    //       productcode: lineItem.productcode,
    //       productdescription: lineItem.productdescription,
    //       notes: lineItem.notes
    //     });
    //   }
    // }
  }

  loadCompetitorForm() {
    this.competitorNegotiationForm = this.fb.group({
      price: ['', Validators.required],
      productcode: ['', Validators.maxLength(50)],
      productdescription: ['', Validators.maxLength(50)],
      notes: ['', Validators.maxLength(50)]
    });
  }

  patchValues() {
    this.competitorNegotiationForm.patchValue({
      price: this.epbtFaCompetitorService.competitorPricingLine.competitorSellPrice,
      productcode: this.epbtFaCompetitorService.competitorPricingLine.competitorProductCode,
      productdescription: this.epbtFaCompetitorService.competitorPricingLine.competitorProductDescription,
      notes: this.epbtFaCompetitorService.competitorPricingLine.notes
    });
    if (this.epbtFaCompetitorService.competitorPricingLine && this.epbtFaCompetitorService.competitorPricingLine.competitorSellPerID) {
      this.selectedPriceId = this.epbtFaCompetitorService.competitorPricingLine.competitorSellPerID;
      this.selectedPrice = this.epbtFaCompetitorService.competitorPricingLine.competitorSellPer;
    } else {
      // var eaches = this.epbtFaCompetitorService.sellPricePers.filter(x => x.name == 'Each');
      // if (eaches && eaches.length > 0) {
      //   this.selectedPriceId = eaches[0].perId;
      // }
      this.selectedPriceId = this.epbtFaCompetitorService.competitorPricingLine.ourSellPer.perId;
      this.selectedPrice = this.epbtFaCompetitorService.competitorPricingLine.ourSellPer;
    }
  }

  // This will be use in html code for validation
  get frmFields() { return this.competitorNegotiationForm.controls; }

  CompetitorSave() {
    this.submitted = true;
    if (this.competitorNegotiationForm.invalid || this.isPriceWarning) {
      return;
    } else {
      // if (this.productService.selectedProductItem && !this.epbtFaCompetitorService.isNegotiationEdit) {
      // let competitorPriceLine: CompetitorPriceLine = new CompetitorPriceLine(this.epbtFaCompetitorService.competitorPricing, this.productService.selectedProductItem, QuantityType.Per);
      this.epbtFaCompetitorService.competitorPricingLine.competitorSellPrice = this.competitorNegotiationForm.controls['price'].value;
      this.epbtFaCompetitorService.competitorPricingLine.competitorSellPerID = this.selectedPriceId;
      this.epbtFaCompetitorService.competitorPricingLine.competitorSellPer = this.selectedPrice;
      this.epbtFaCompetitorService.competitorPricingLine.notes = this.competitorNegotiationForm.controls['notes'].value;
      this.epbtFaCompetitorService.competitorPricingLine.competitorProductCode = this.competitorNegotiationForm.controls['productcode'].value;
      this.epbtFaCompetitorService.competitorPricingLine.competitorProductDescription = this.competitorNegotiationForm.controls['productdescription'].value;

      // this.epbtFaCompetitorService.competitorPricing.Lines.push(competitorPriceLine);
      const index = this.epbtFaCompetitorService.competitorPricing.Lines.findIndex(x => x.lineNumber == this.epbtFaCompetitorService.competitorPricingLine.lineNumber);
      if (index != -1) {
        this.epbtFaCompetitorService.competitorPricing.Lines[index] = this.epbtFaCompetitorService.competitorPricingLine;
      } else {
        this.epbtFaCompetitorService.competitorPricing.LineAdd(this.epbtFaCompetitorService.competitorPricingLine);
      }

      //  this.epbtFaCompetitorService.competitorPricing.LineAdd(this.epbtFaCompetitorService.competitorPricingLine)
      // }


      // if (this.productService.selectedProductItem && !this.epbtFaCompetitorService.isNegotiationEdit) {
      //   this.epbtFaCompetitorService.selectedProductsForBinding.push({
      //     product: this.productService.selectedProductItem,
      //     price: this.competitorNegotiationForm.controls['price'].value,
      //     productcode: this.competitorNegotiationForm.controls['productcode'].value,
      //     productdescription: this.competitorNegotiationForm.controls['productdescription'].value,
      //     notes: this.competitorNegotiationForm.controls['notes'].value,
      //     selectPrice: this.selectedPriceId,
      //     line: this.epbtFaCompetitorService.selectedProductsForBinding.length + 1
      //   })
      //   // console.log(this.epbtFaCompetitorService.selectedProductsForBinding);
      // }
      // else {
      //   if (this.epbtFaCompetitorService.selectedProductsForBinding.length > 0) {
      //     let lineItem = this.epbtFaCompetitorService.selectedProductsForBinding.find(item => item.product.productId == this.productId);
      //     let index = this.epbtFaCompetitorService.selectedProductsForBinding.findIndex(item => item.product.productId == this.productId);
      //     if (lineItem && index != -1) {
      //       lineItem.price = this.competitorNegotiationForm.controls['price'].value;
      //       lineItem.productcode = this.competitorNegotiationForm.controls['productcode'].value;
      //       lineItem.productdescription = this.competitorNegotiationForm.controls['productdescription'].value;
      //       lineItem.notes = this.competitorNegotiationForm.controls['notes'].value;
      //       lineItem.selectPrice = this.selectedPriceId;
      //       this.epbtFaCompetitorService.selectedProductsForBinding[index] = lineItem;

      //     }
      //     this.epbtFaCompetitorService.isNegotiationEdit = false;
      //   }
      // }
    }
    this.route.navigate(['/home/competitor']);
  }


  cancelCompetitorNegotiationClicked() {
    //  / this.location.back();
    this.route.navigate(['/home/competitor']);
  }

  onValueChange(selectedValue: any): void {
    if (selectedValue) {
      this.selectedPrice = selectedValue;
      this.selectedPriceId = selectedValue.perId;
      // this.epbtFaCompetitorService.competitorPricingLine.competitorSellPerID = selectedValue.perId;
      // this.epbtFaCompetitorService.competitorPricingLine.competitorSellPer = selectedValue;
    }
  }

  // numberOnly(event): boolean {
  //   const charCode = (event.which) ? event.which : event.keyCode;
  //   if (charCode > 31 && (charCode < 48 || charCode > 57)) {
  //     return false;
  //   }
  //   return true;
  // }

  onPriceFieldChanged(event) {
    this.isPriceWarning = false;
    const qty = event.target.value;
    if (qty && parseFloat(qty) > 999999) {
      this.isPriceWarning = true;
    }
  }
}
